module.exports = __webpack_public_path__ + "img/number03.69117a69.svg";